import _RadioGroup from "@material-ui/core/esm/RadioGroup";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useState } from 'react';
import Slider from 'react-slick';
import { is1024andSmaller } from 'swag-client-common/utils/ui.utils';
import { SPECIAL_PRODUCT_TYPES } from 'swag-common/constants/product.constants';
import BottomButtons from '../bottom-buttons';
import { BoxCardItem } from '../box-card-item';
import classes from './box-type-selection.scss';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
const sliderSettings = {
  infinite: false,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows: false,
  variableWidth: true,
  dots: false,
  draggable: false,
  swipe: false,
  touchMove: false,
  responsive: [{
    breakpoint: 1024,
    settings: {
      dots: true,
      draggable: true,
      swipe: true,
      touchMove: true,
      centerMode: true
    }
  }]
};
export function BoxTypeSelectionComponent({
  onNext,
  onBackButton,
  selectedBoxType,
  isBoxTypeEdit = false,
  hasUnsavedChanges,
  onChange,
  boxTypes = []
}) {
  const [boxType, setBoxType] = useState(selectedBoxType || SPECIAL_PRODUCT_TYPES.CUSTOM_BOX);
  const isMobile = is1024andSmaller();
  const findTypeIndex = type => boxTypes.findIndex(t => t.type === type);
  const onBoxTypeChange = type => {
    setBoxType(type);
    onChange(type);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.boxTypeSelectionContent
  }, /*#__PURE__*/React.createElement("h1", {
    className: classes.title
  }, "Select what type of box you want!"), /*#__PURE__*/React.createElement(_RadioGroup, {
    "aria-label": "boxType",
    name: "boxType",
    classes: {
      root: classes.radioGroupRoot
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.sliderWrapper
  }, /*#__PURE__*/React.createElement(Slider, _extends({}, sliderSettings, {
    initialSlide: isMobile ? findTypeIndex(boxType) : 0
  }), boxTypes.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.type
  }, /*#__PURE__*/React.createElement(BoxCardItem, {
    boxTypeItem: item,
    selectedType: boxType,
    onBoxTypeChange: onBoxTypeChange
  })))))), /*#__PURE__*/React.createElement(BottomButtons, {
    backText: isBoxTypeEdit ? 'Cancel' : 'Back',
    buttonsWrapperClassName: classes.buttonsWrapper,
    onBackButton: () => onBackButton(isBoxTypeEdit, hasUnsavedChanges),
    isDisabledNextButton: false,
    onNextButton: () => onNext(boxType)
  }));
}